/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import { node } from "prop-types";
import React, {useEffect, useState} from "react";
import WorkImage from "../../../../assets/images/workbrook-bg-new.png";
import WBtext from "../../../../assets/icons/WBtext.svg";
import "./index.scss";
import { useDispatch, useSelector } from "react-redux";

import { getJobListAction } from "../../../../redux/actions/jobActions";
import PlatformDisclaimer from "../../../../components/PlatformDisclaimer";


const AuthWrapper = ({ children }) => {

  const dispatch = useDispatch();
  const {jobList} = useSelector((store) => store);

  const [sectionLoading, setSectionLoading] = useState(true);

  useEffect(() => {
    Promise.resolve(getJobListAction(dispatch)).finally(() => 
    {
      setTimeout( ()=>{
        setSectionLoading(false);
      }, 1000);
    }
    
    );
  }, [dispatch, 1]);

  return (
    <div
      className="auth signin"
      style={{
        background: "#3A6ED4",
      }}
    >
     {/* <br/><br/>
        <a href="job-lists" className="job-board-btn custom-button" >Go to Job Board</a>
      */}
      <div className="wrapper d-flex align-items-center justify-content-center flex-column flex-md-row">
        <div className="d-none d-md-flex flex-column justify-content-center w-50 p-3">
          <img
            style={{ width: "60%", display: "block", margin: "0 auto" }}
            src={WorkImage}
            alt="logo"
          />

          <img
            style={{ width: "80%", display: "block", margin: "0 auto" }}
            src={WBtext}
            alt="logo"
          />
          <h4
            className="co-white text-center mt-2"
            style={{
              fontSize: "30px",
            }}
          >
            Market Place
          </h4>
         
        </div>
        {children}
      </div>
      <PlatformDisclaimer />
    </div>
  );
};

AuthWrapper.propTypes = {
  children: node.isRequired,
};

export default AuthWrapper;
